import { useState } from "react";

function ago(iso) {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

// Exact timestamp incl. seconds + milliseconds, e.g. "20 Sep 2026, 10:22:58.399"
export function exact(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const base = d.toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  });
  return `${base}.${String(d.getMilliseconds()).padStart(3, "0")}`;
}

export function RelativeTime({ iso, className = "" }) {
  const [show, setShow] = useState(false);
  if (!iso) return <span className="text-slate-400">—</span>;
  const full = exact(iso);
  return (
    <button
      type="button"
      title={full}
      data-testid="relative-time"
      onClick={(e) => { e.stopPropagation(); setShow((v) => !v); }}
      className={`cursor-pointer underline decoration-dotted decoration-slate-300 underline-offset-2 hover:text-teal-600 ${className}`}
    >
      {show ? full : ago(iso)}
    </button>
  );
}
